import { animate, style, transition, trigger } from '@angular/animations';

export const slideInOutAnimation = trigger('slideInOut', [
  transition(':enter', [
    style({ transform: 'translateX(431px)' }),
    animate('0.3s cubic-bezier(.25, .8, .25, 1)', style({ transform: 'translateX(0%)' })),
  ]),
  transition(':leave', [animate('0.3s cubic-bezier(.25, .8, .25, 1)', style({ transform: 'translateX(431px)' }))]),
]);
